/* 
 * Copyright 2020 Dreamgest ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var server = {
  app: null,
  applicationId: 'imc_fa6c9b80469e81c2c5f4e6f65a62',
  token: function (token) {
    if (token === undefined) {
      return localStorage.token || '';
    } else {
      localStorage.token = token;
      return token;
    }
  },
  get: function (api) {
    return server.request(api, 'GET');
  },
  post: function (api, data) {
    return server.request(api, 'POST', data);
  },
  put: function (api, data) {
    return server.request(api, 'PUT', data);
  },
  patch: function (api, data) {
    return server.request(api, 'PATCH', data);
  },
  "delete": function (api, data) {
    return server.request(api, 'DELETE', data);
  },
  head: function (api) {
    return server.request(api, 'HEAD');
  },
  request: function (api, method, data) {
    var self = server;
    method = method || 'GET';
    const host = server.app.device.cordova ? 'api.dreamgest.com' : 'app.infomycity.eu';
    return new Promise(function (resolve, reject) {
      self.app.request({
        success: function (x) {
          resolve(x);
        },
        error: function (x) {
          var data = {
            status: x.status,
            statusText: x.statusText,
            response: server.parseJSON(x.responseText)
          };
          reject(data);
        },
        url:  'https://' + host + '/infomycity/' + api, // imcweb
        method: method,
        dataType: 'json',
        processData: false,
        crossDomain: true,
        headers: {
          "X-Application-Id": self.applicationId,
          "X-Auth-Token": server.token()
        },
        data: JSON.stringify(data)
      });
    });
  },
  parseJSON: function (str) {
    var x;
    try {
      x = JSON.parse(str);
    } catch (e) {
      x = str;
    }
    return x;
  }
};

export default server;